import { motion } from "framer-motion";
import { PencilSimple, Trash } from "@phosphor-icons/react";

// The Roster tab table on Admin — extracted verbatim (no behavior change).
export function RosterTable({ players, onTogglePlayerActive, onEditPlayer, onDeletePlayer }) {
  return (
    <div className="border border-zinc-800 rounded-sm overflow-hidden" data-testid="admin-roster-table">
      <div className="grid grid-cols-[60px_1fr_1fr_100px_80px] gap-4 px-4 py-3 bg-[#121212] border-b border-zinc-800">
        <span className="font-label text-[10px] text-zinc-500">#</span>
        <span className="font-label text-[10px] text-zinc-500">Name</span>
        <span className="font-label text-[10px] text-zinc-500 hidden sm:block">Position</span>
        <span className="font-label text-[10px] text-zinc-500">Status</span>
        <span className="font-label text-[10px] text-zinc-500 text-right">Actions</span>
      </div>
      {players.map((p, i) => (
        <motion.div
          key={p.id}
          initial={{ opacity: 0, y: 6 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: i * 0.03 }}
          className="grid grid-cols-[60px_1fr_1fr_100px_80px] gap-4 px-4 py-3 items-center border-b border-zinc-900 hover:bg-white/5 transition-colors duration-150"
          data-testid={`admin-player-row-${p.jersey_number}`}
        >
          <span className="font-heading text-2xl text-[#CCFF00]">{p.jersey_number}</span>
          <div>
            <p className="text-white font-semibold">{p.first_name} {p.last_name}</p>
            <p className="text-zinc-500 text-xs sm:hidden">{p.position || "—"}</p>
          </div>
          <span className="text-zinc-300 text-sm hidden sm:block">{p.position || <span className="text-zinc-600">—</span>}</span>
          <button
            onClick={() => onTogglePlayerActive(p)}
            data-testid={`admin-toggle-active-${p.jersey_number}`}
            className={`font-label text-[10px] px-2 py-1 rounded-sm w-fit transition-colors duration-150 ${
              p.active ? "text-[#CCFF00] bg-[#CCFF00]/10 hover:bg-[#CCFF00]/20" : "text-zinc-500 bg-zinc-800/50 hover:bg-zinc-800"
            }`}
          >
            {p.active ? "Active" : "Inactive"}
          </button>
          <div className="flex items-center justify-end gap-1">
            <button onClick={() => onEditPlayer(p)} data-testid={`admin-edit-player-${p.jersey_number}`} className="p-2 text-zinc-400 hover:text-white transition-colors duration-150">
              <PencilSimple size={16} weight="bold" />
            </button>
            <button onClick={() => onDeletePlayer(p)} data-testid={`admin-delete-player-${p.jersey_number}`} className="p-2 text-zinc-400 hover:text-[#FF3B30] transition-colors duration-150">
              <Trash size={16} weight="bold" />
            </button>
          </div>
        </motion.div>
      ))}
      {players.length === 0 && (
        <p className="text-zinc-600 text-sm px-4 py-6" data-testid="admin-roster-empty">No players yet — add your first player to build the roster.</p>
      )}
    </div>
  );
}
